<ion-app>
	<ion-split-pane contentId="main-content" [disabled]="fire.splitPaneIsLocked">
		<ion-menu contentId="main-content" type="overlay" [disabled]="fire.splitPaneIsLocked">
			<ion-content> </ion-content>
		</ion-menu>
		<ion-router-outlet id="main-content"></ion-router-outlet>
	</ion-split-pane>
</ion-app>
